if (typeof window.__CART__CONTROLLER__ == 'undefined') {
  window.__CART__CONTROLLER__ = {
    fetchingCart: null,
    async get () {
      if (this.fetchingCart) {
        return this.fetchingCart.promise
      }

      this.fetchingCart = new Deferred()
      const data = await fetch(window.routes.cart_url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.json()).then(data => data)

      if (data?.items) {
        window.__CART__ = { ...data }
      }

      this.fetchingCart.resolve()
      this.fetchingCart = null

      return { ...data }
    },
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    },
    reRenderSections (cart) {
      document.querySelectorAll(".js-product-totals").forEach(el => {
        if (cart.item_count > 9) {
          el.innerText = '9+';
        } else {
          el.innerText = cart.item_count;
        }
      });

      document.querySelectorAll(".js-cart-product-totals").forEach(el => {
        if (cart.item_count === 0) {
          el.innerText = "";
        } else if (cart.item_count === 1) {
          el.innerText = "1 item";
        } else {
          el.innerText = `${cart.item_count} items`;
        }
      })

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            .querySelector(section.selector) ||
          document.getElementById(section.id)

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          cart.sections[section.section],
          section.selector
        )
      })
    },
    getSectionsToRender () {
      const isCartPage = document.body.classList.contains('template-cart')
      const cartId = isCartPage ? 'cart-page' : 'mini-cart'
      return [
        {
          id: cartId,
          section: document.getElementById(cartId).dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '#cart-icon-bubble',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
      ]
    },
    async updateCartFreeGift (cart = null) {
      if (!cart) {
        cart = await this.get()
      }

      const free_gift_product = window.settings.free_gift_product
      const enable_free_gift = window.settings.enable_free_gift === 'true'
      const free_gift_threshold = window.settings.free_gift_threshold * 100
      const alreadyInCart = cart.items.some(i => i.id === Number(free_gift_product))
      const isEligible = cart.total_price >= free_gift_threshold && enable_free_gift

      return new Promise((resolve) => {
        let quantity = 0;
        let route = routes.cart_change_url;

        if ((alreadyInCart && isEligible) || (!alreadyInCart && !isEligible)) {
          resolve(cart)
          return
        }

        if (!alreadyInCart && isEligible) {
          quantity = 1;
          route = routes.cart_add_url;
        }

        if (window.sessionStorage.getItem('gwp_removed')) {
          resolve(cart)
          return
        }

        const payload = {
          id: free_gift_product,
          quantity,
          properties: {
            '_free-gift': true
          },
        }

        fetch(route, {
          ...fetchConfig(),
          body: JSON.stringify({
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
            ...payload,
          }),
        })
        .then(response => response.text())
        .then(state => {
          let updatedCart = cart
          const parsedState = JSON.parse(state)

          if (route === routes.cart_change_url) {
            updatedCart = parsedState
          } else if (route === routes.cart_add_url) {
            let itemAlreadyInCart = false
            if (updatedCart.items.length) {
              updatedCart.items.map((item) => {
                if (item.id === parsedState.id) {
                  item.quantity = parsedState.quantity
                  itemAlreadyInCart = true
                }
              })
            }
            if (!itemAlreadyInCart) {
              updatedCart.items.push(parsedState)
            }

            updatedCart.item_count = updatedCart.items.reduce((prev, curr) => prev + curr.quantity, 0)
            updatedCart.sections = parsedState.sections
          }

          resolve(updatedCart)
        })
      })
    }
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()

      if (this.closest('.cart-item[data-gwp="true"]')) {
        window.sessionStorage.setItem('gwp_removed', true)
      }

      this.closest('cart-items').updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status'
    )

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    )
  }

  updateQuantity(line, quantity, name) {
    // this.enableLoading(line);  // Will update in loading ticket

    const body = JSON.stringify({
      line,
      quantity,
      sections: __CART__CONTROLLER__.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then(async (state) => {
        const parsedState = await __CART__CONTROLLER__.updateCartFreeGift(JSON.parse(state))
        window.__CART__ = parsedState
        __CART__CONTROLLER__.updateCartFreeGift(parsedState)
        this.classList.toggle('is-empty', parsedState.item_count === 0)

        document.querySelectorAll(".js-product-totals").forEach(el => {
          if (parsedState.item_count > 9) {
            el.innerText = '9+';
          } else {
            el.innerText = parsedState.item_count;
          }
        });

        document.querySelectorAll(".js-cart-product-totals").forEach(el => {
          if (parsedState.item_count === 0) {
            el.innerText = "";
          } else if (parsedState.item_count === 1) {
            el.innerText = "1 item";
          } else {
            el.innerText = `${parsedState.item_count} items`;
          }
        })

        __CART__CONTROLLER__.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = __CART__CONTROLLER__.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })

        this.updateLiveRegions(line, parsedState.item_count)
      })
      .catch(() => {
        // this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        if (document.getElementById('cart-errors')) {
          document.getElementById('cart-errors').textContent =
            window.cartStrings.error
        }
        // this.disableLoading();
      })
      .finally(() => {
        document.querySelector(".js-product-recommendations")?.classList.remove("loading");
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  enableLoading(line) {
    document.getElementById('cart-items').classList.add('cart__items--disabled')
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove(
      'hidden'
    )
    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading() {
    if (document.getElementById('cart-items')) {
      document
        .getElementById('cart-items')
        .classList.remove('cart__items--disabled')
    }
  }
}
customElements.define('cart-items', CartItems)

class CartCheckoutButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.classList.add('loading')

      const body = JSON.stringify({
        note,
      })
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
        .then((response) => (location.href = '/checkout'))
        .catch((e) => {
          this.classList.remove('loading')
          console.error(e)
        })
    })
  }
}

customElements.define('cart-checkout-button', CartCheckoutButton)

document.addEventListener('click', async (e) => {
  if (!e.target.closest('.js-add-free-gift')) {
    return
  }

  e.preventDefault()

  window.sessionStorage.removeItem('gwp_removed')
  const cart = await __CART__CONTROLLER__.updateCartFreeGift()
  __CART__CONTROLLER__.reRenderSections(cart)
})